import { render, staticRenderFns } from "./payType.vue?vue&type=template&id=3992377c&scoped=true"
import script from "./payType.vue?vue&type=script&lang=js"
export * from "./payType.vue?vue&type=script&lang=js"
import style0 from "./payType.vue?vue&type=style&index=0&id=3992377c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3992377c",
  null
  
)

export default component.exports